/**
 * FIX-286: appliance reuse lookups are always limited to the ACTIVE company,
 * also for superadmins (who can read every company's appliances via RLS).
 */
export class MissingActiveCompanyError extends Error {
  constructor() {
    super("No active company — cannot look up appliances for reuse.");
    this.name = "MissingActiveCompanyError";
  }
}

export function scopeToCompany<Q extends { eq: (column: string, value: string) => Q }>(
  query: Q,
  companyId: string | null | undefined,
): Q {
  if (!companyId) throw new MissingActiveCompanyError();
  return query.eq("company_id", companyId);
}

/** Drops rows from another company (defence in depth for reuse matches). */
export function onlyActiveCompany<T extends { company_id?: string | null }>(rows: T[], companyId: string): T[] {
  return rows.filter((r) => r.company_id === companyId);
}
